export function trimTrailingSlash(path) {
  return path.replace(/(?<!^)\/$/, "");
}
